/* ==========================================================================
   Wefty Design — 10'lu paket kurucu
   sections/wefty-paket-kur.liquid tarafından kullanılır.

   NEDEN AYRI ÜRÜN AÇILMADI: Enes'in isteği "müşteri seçenekleri olabildiğince
   özgürce seçsin" (2026-08-31). Sabit içerikli bir "10'lu Paket" ürünü bunun
   tam tersi olurdu — içeriği biz seçerdik. Bunun yerine müşteri 155 parçalık
   satıştaki katalogdan istediği 10 parçayı seçiyor, hepsi tek tıkla sepete
   ekleniyor ve indirim Shopify'ın OTOMATİK İNDİRİM kuralından geliyor.

   İNDİRİM BURADA HESAPLANMAZ, YALNIZCA ÖNİZLENİR. Gerçek indirim sepette ve
   ödeme adımında Shopify tarafından uygulanır. Buradaki rakam bir tahmindir ve
   arayüzde de böyle yazar — yanlış fiyat sözü vermemek için (PROJECT.md §10
   risk 2 ile aynı ilke).

   Ürün verisi mağazanın kendi `/collections/<handle>/products.json` ucundan
   gelir. Bu uç YALNIZCA satıştaki (active + online store) ürünleri döndürür,
   yani taslaktaki 106 ürün kurucuda hiç görünmez — istediğimiz davranış bu.
   ========================================================================== */

(function () {
  'use strict';

  var VARSAYILAN_OLCEK = 'M';

  function paraBicimlendir(tutar, kod, dil) {
    try {
      return new Intl.NumberFormat(dil || 'tr-TR', {
        style: 'currency',
        currency: kod || 'TRY',
        minimumFractionDigits: 2,
      }).format(tutar);
    } catch (e) {
      return tutar.toFixed(2) + ' ' + (kod || '');
    }
  }

  function el(etiket, sinif, metin) {
    var d = document.createElement(etiket);
    if (sinif) d.className = sinif;
    if (metin != null) d.textContent = metin;
    return d;
  }

  /* Tek başına ürün adı OLAMAYAN sözcükler.
     ⚠️ `snippets/wefty-urun-adi.liquid` içindeki `nitelik_listesi` ile AYNI
     OLMALI — kart ve koleksiyon aynı adı basıyor. Gerekçesi ve ölçütü orada
     uzun uzun yazılı; iki yerde iki farklı görünüm olmasın diye elle senkron. */
  var NITELIK = ('gerçekçi,küçük,büyük,düşük,poligon,diorama,sürat,antika,standlı,' +
    'yüzer,ahşap,sade,hasır,çatılı,klasik,ölçekli,sınıf,parmak,boyu,su,üstü,tarama,' +
    'oyuncak,stilize,silüet,tarihî,tarihi,tip,korsan,devriye,yük,ayakta,oturan,erkek,' +
    'kadın,kıyı,dokusu,trol,hindistan,cevizli,ölçek,batık,modern,oynar,eklemli,plaj,' +
    'bağlama,karakteristik,parça,1:10,1:35,1:87,1:100,1:148').split(',');

  /* Ürün adını iki satıra ayırır — `wefty-urun-adi.liquid` ile AYNI KURAL.
     Ad şeması "{Tip} No.{n} — {Niteleyici}". Niteleyici kelime kelime
     sınıflandırılır: en az bir AD kelimesi varsa o öne geçer, hepsi NİTELİK
     ise tipin kendisi öne geçer. */
  function adAyir(ad) {
    var parca = ad.split(' — ');
    var sol = parca[0].trim();
    var nit = parca.length > 1 ? parca.slice(1).join(' — ').trim() : '';
    var tipParca = sol.split(' No.');
    var tip = tipParca[0].trim();
    var numara = tipParca.length > 1 ? tipParca[1].trim() : '';

    var adK = [], nitK = [];
    if (nit) {
      nit.split(/\s+/).forEach(function (k) {
        (NITELIK.indexOf(k.toLocaleLowerCase('tr-TR')) !== -1 ? nitK : adK).push(k);
      });
    }

    var ust, parcalar = [];
    if (adK.length) {
      ust = adK.join(' ');
      if (nitK.length) parcalar.push(nitK.join(' '));
      parcalar.push(tip.replace(/^Minyatür\s+/, '').trim());
    } else {
      ust = tip;
      if (nitK.length) parcalar.push(nitK.join(' '));
    }
    if (numara) parcalar.push('No.' + numara);
    return { ust: ust, alt: parcalar.join(' · ') };
  }

  /* Ürünün tip etiketinden ölçü merdivenini bulur.
     Kaynak `assets/wefty-olculer.js` (TIP tablosundan üretiliyor); dosya
     yüklenmemişse ya da tip eşleşmezse null döner ve mm satırı hiç basılmaz —
     uydurma ölçü göstermektense boş kalsın. */
  function olcuBul(tags) {
    var harita = window.WEFTY_OLCULER;
    if (!harita || !tags) return null;
    for (var i = 0; i < tags.length; i++) {
      var t = String(tags[i]).toLocaleLowerCase('tr-TR').trim();
      if (harita[t]) return harita[t];
    }
    return null;
  }

  function WeftyPaket(kok) {
    this.kok = kok;
    /* Kademeler "adet:yuzde" çiftlerinden okunuyor, artan sıraya diziliyor.
       Mağaza tarafında üç ayrı otomatik indirim var (37_paket_kurulum.py →
       KADEMELER) ve Shopify hangisi daha çok indiriyorsa onu uyguluyor;
       buradaki liste onunla AYNI olmalı, yoksa vitrin sepetten farklı söz verir. */
    this.kademeler = (kok.dataset.kademeler || '10:15').split(',')
      .map(function (c) {
        var p = c.split(':');
        return { adet: parseInt(p[0], 10), yuzde: parseFloat(p[1]) };
      })
      .filter(function (k) { return k.adet > 0 && k.yuzde > 0; })
      .sort(function (a, b) { return a.adet - b.adet; });
    if (!this.kademeler.length) this.kademeler = [{ adet: 10, yuzde: 15 }];
    this.hedef = this.kademeler[0].adet;
    this.kargoEsik = parseFloat(kok.dataset.kargoEsik) || 0;
    this.paraKodu = kok.dataset.para || 'TRY';
    this.dil = kok.dataset.dil || 'tr-TR';
    this.havuzlar = JSON.parse(kok.dataset.havuzlar || '[]');

    this.onbellek = {};          // handle -> ürün dizisi
    this.urunler = [];           // görüntülenen havuz
    this.secim = [];             // {urunId, varyantId, ad, olcek, fiyat, gorsel, handle}
    this.olcek = VARSAYILAN_OLCEK;
    this.arama = '';
    this.siralama = 'varsayilan';
    this.aktifHavuz = this.havuzlar.length ? this.havuzlar[0].handle : null;

    this.izgara = kok.querySelector('[data-wf-izgara]');
    this.ozet = kok.querySelector('[data-wf-ozet]');
    this.sayacEl = kok.querySelector('[data-wf-sayac]');
    this.listeEl = kok.querySelector('[data-wf-liste]');
    this.durumEl = kok.querySelector('[data-wf-durum]');
    this.kargoEl = kok.querySelector('[data-wf-kargo]');
    this.ekleDugme = kok.querySelector('[data-wf-ekle]');
    this.temizleDugme = kok.querySelector('[data-wf-temizle]');
    this.aramaAlan = kok.querySelector('[data-wf-arama]');
    this.siralaAlan = kok.querySelector('[data-wf-sirala]');

    this.baglantiKur();
    if (this.aktifHavuz) this.havuzYukle(this.aktifHavuz);
    this.ozetCiz();
  }

  WeftyPaket.prototype.baglantiKur = function () {
    var self = this;

    this.kok.querySelectorAll('[data-wf-havuz]').forEach(function (d) {
      d.addEventListener('click', function () {
        self.aktifHavuz = d.dataset.wfHavuz;
        self.kok.querySelectorAll('[data-wf-havuz]').forEach(function (x) {
          x.setAttribute('aria-pressed', String(x === d));
        });
        self.havuzYukle(self.aktifHavuz);
      });
    });

    this.kok.querySelectorAll('[data-wf-olcek]').forEach(function (d) {
      d.addEventListener('click', function () {
        self.olcek = d.dataset.wfOlcek;
        self.kok.querySelectorAll('[data-wf-olcek]').forEach(function (x) {
          x.setAttribute('aria-pressed', String(x === d));
        });
        self.izgaraCiz();
      });
    });

    if (this.aramaAlan) {
      this.aramaAlan.addEventListener('input', function () {
        self.arama = this.value.toLocaleLowerCase('tr-TR').trim();
        self.izgaraCiz();
      });
    }

    if (this.siralaAlan) {
      this.siralaAlan.addEventListener('change', function () {
        self.siralama = this.value;
        self.izgaraCiz();
      });
    }

    if (this.ekleDugme) {
      this.ekleDugme.addEventListener('click', function () {
        self.sepeteEkle();
      });
    }

    if (this.temizleDugme) {
      this.temizleDugme.addEventListener('click', function () {
        self.secim = [];
        self.izgaraCiz();
        self.ozetCiz();
      });
    }
  };

  WeftyPaket.prototype.havuzYukle = function (handle) {
    var self = this;

    if (this.onbellek[handle]) {
      this.urunler = this.onbellek[handle];
      this.izgaraCiz();
      return;
    }

    this.izgara.innerHTML = '';
    this.izgara.appendChild(el('p', 'wf-paket__bilgi', 'Katalog yükleniyor…'));

    fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root + 'collections/' + handle + '/products.json?limit=250'
      : '/collections/' + handle + '/products.json?limit=250')
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (d) {
        var liste = (d.products || []).map(function (p) {
          return {
            id: p.id,
            handle: p.handle,
            ad: p.title,
            gorsel: p.images && p.images.length ? p.images[0].src : null,
            olcu: olcuBul(p.tags),
            varyantlar: (p.variants || []).map(function (v) {
              return { id: v.id, olcek: v.title, fiyat: parseFloat(v.price) };
            }),
          };
        });
        self.onbellek[handle] = liste;
        if (self.aktifHavuz === handle) {
          self.urunler = liste;
          self.izgaraCiz();
        }
      })
      .catch(function (e) {
        self.izgara.innerHTML = '';
        var p = el('p', 'wf-paket__bilgi wf-paket__bilgi--hata',
          'Katalog yüklenemedi. Sayfayı yenilemeyi deneyin.');
        self.izgara.appendChild(p);
        if (window.console) console.error('[wefty-paket]', e);
      });
  };

  WeftyPaket.prototype.varyantBul = function (urun, olcek) {
    for (var i = 0; i < urun.varyantlar.length; i++) {
      if (urun.varyantlar[i].olcek === olcek) return urun.varyantlar[i];
    }
    /* Şamandırada S kademesi yok (PROJECT.md §4.7 — üç kademeyle satılıyor).
       İstenen kademe o üründe yoksa en yakın alt kademeye düşülmez,
       ürünün İLK kademesi kullanılır ve arayüzde hangi kademe olduğu yazar. */
    return urun.varyantlar[0] || null;
  };

  WeftyPaket.prototype.secimIndeksi = function (varyantId) {
    for (var i = 0; i < this.secim.length; i++) {
      if (this.secim[i].varyantId === varyantId) return i;
    }
    return -1;
  };

  /* Verilen adette geçerli olan kademe (yoksa null) ve bir sonraki kademe. */
  WeftyPaket.prototype.aktifKademe = function (adet) {
    var bulunan = null;
    for (var i = 0; i < this.kademeler.length; i++) {
      if (adet >= this.kademeler[i].adet) bulunan = this.kademeler[i];
    }
    return bulunan;
  };

  WeftyPaket.prototype.sonrakiKademe = function (adet) {
    for (var i = 0; i < this.kademeler.length; i++) {
      if (adet < this.kademeler[i].adet) return this.kademeler[i];
    }
    return null;
  };

  WeftyPaket.prototype.adet = function () {
    return this.secim.reduce(function (t, s) { return t + s.adet; }, 0);
  };

  WeftyPaket.prototype.araToplam = function () {
    return this.secim.reduce(function (t, s) { return t + s.fiyat * s.adet; }, 0);
  };

  WeftyPaket.prototype.izgaraCiz = function () {
    var self = this;
    this.izgara.innerHTML = '';

    var gorunen = this.urunler.filter(function (u) {
      if (!self.arama) return true;
      return u.ad.toLocaleLowerCase('tr-TR').indexOf(self.arama) !== -1;
    });

    /* Sıralama. Fiyat ve mm SEÇİLİ KADEMEDEN okunuyor — S'in fiyatı başka,
       XL'in başka; ölçek değişince sıra da değişmeli. Kademesi olmayan ürün
       (ör. şamandırada S) listenin sonuna atılıyor, ortada kaybolmasın.
       `slice()` ile kopya üzerinde sıralanıyor: `this.urunler` havuzun önbelleği,
       sırasını bozarsak "Katalog sırası" seçeneği geri gelemezdi. */
    if (this.siralama !== 'varsayilan') {
      var anahtar = function (u) {
        var v = self.varyantBul(u, self.olcek);
        if (!v) return null;
        if (self.siralama.indexOf('fiyat') === 0) return v.fiyat;
        if (self.siralama.indexOf('olcu') === 0) {
          return u.olcu && u.olcu.mm ? u.olcu.mm[v.olcek] : null;
        }
        return null;
      };
      var azalan = this.siralama.indexOf('azalan') !== -1;
      gorunen = gorunen.slice();
      if (this.siralama === 'ad') {
        gorunen.sort(function (a, b) {
          return adAyir(a.ad).ust.localeCompare(adAyir(b.ad).ust, 'tr');
        });
      } else {
        gorunen.sort(function (a, b) {
          var x = anahtar(a), y = anahtar(b);
          if (x == null && y == null) return 0;
          if (x == null) return 1;
          if (y == null) return -1;
          return azalan ? y - x : x - y;
        });
      }
    }

    if (!gorunen.length) {
      this.izgara.appendChild(el('p', 'wf-paket__bilgi',
        this.arama ? 'Aramaya uyan parça yok.' : 'Bu havuzda satışta parça yok.'));
      return;
    }

    gorunen.forEach(function (u) {
      var v = self.varyantBul(u, self.olcek);
      if (!v) return;
      self.izgara.appendChild(self.kartYap(u, v));
    });
  };

  /* Tek bir kartın DOM'unu üretir. Ayrı fonksiyon olmasının sebebi: parça
     eklenip çıkarıldığında 155 kartlık ızgarayı baştan çizmek yerine YALNIZ
     etkilenen kart yenileniyor (bkz. kartTazele). Telefonda fark ediliyordu. */
  WeftyPaket.prototype.kartYap = function (u, v) {
    var self = this;
    var i = this.secimIndeksi(v.id);
    var secili = i !== -1;
    var adet = secili ? this.secim[i].adet : 0;

    var kart = el('div', 'wf-paket-kart' + (secili ? ' is-secili' : ''));
    kart.dataset.varyant = String(v.id);
    kart.dataset.urun = String(u.id);

    var gorselKutu = el('div', 'wf-paket-kart__gorsel');
    if (u.gorsel) {
      var img = document.createElement('img');
      img.src = u.gorsel.replace(/(\.[a-z]+)(\?|$)/i, '_400x$1$2');
      img.alt = u.ad;
      img.loading = 'lazy';
      gorselKutu.appendChild(img);
    }
    kart.appendChild(gorselKutu);

    var ad = adAyir(u.ad);
    var govde = el('div', 'wf-paket-kart__govde');
    govde.appendChild(el('span', 'wf-paket-kart__ad', ad.ust));
    if (ad.alt) govde.appendChild(el('span', 'wf-paket-kart__tip', ad.alt));

    var satir = el('div', 'wf-paket-kart__satir');
    var solKutu = el('span', 'wf-paket-kart__sol');
    solKutu.appendChild(el('span', 'wf-paket-kart__olcek', v.olcek));

    /* Enes 2026-08-31: "M'ye basınca ürünün sadece fiyatı değil kaç mm olduğu
       da gözükse süper olur." Ölçü, kademeye göre değişiyor — seçili kademenin
       mm'si basılıyor, ürünün o kademesi yoksa hiç basılmıyor. */
    var mm = u.olcu && u.olcu.mm ? u.olcu.mm[v.olcek] : null;
    if (mm) {
      solKutu.appendChild(el('span', 'wf-paket-kart__mm', mm + ' mm'));
    }
    satir.appendChild(solKutu);
    satir.appendChild(el('span', 'wf-paket-kart__fiyat',
      paraBicimlendir(v.fiyat, self.paraKodu, self.dil)));
    govde.appendChild(satir);
    kart.appendChild(govde);

    var aksiyon = el('div', 'wf-paket-kart__aksiyon');
    if (secili) {
      var eksi = el('button', 'wf-paket-kart__adim', '−');
      eksi.type = 'button';
      eksi.setAttribute('aria-label', u.ad + ' adedini azalt');
      eksi.addEventListener('click', function (ev) {
        ev.stopPropagation();
        self.azalt(u, v);
      });
      var sayi = el('span', 'wf-paket-kart__adet', String(adet));
      var arti = el('button', 'wf-paket-kart__adim', '+');
      arti.type = 'button';
      arti.setAttribute('aria-label', u.ad + ' adedini artır');
      arti.addEventListener('click', function (ev) {
        ev.stopPropagation();
        self.artir(u, v);
      });
      aksiyon.appendChild(eksi);
      aksiyon.appendChild(sayi);
      aksiyon.appendChild(arti);
    } else {
      var ekle = el('button', 'wf-paket-kart__sec', 'Pakete ekle');
      ekle.type = 'button';
      ekle.addEventListener('click', function (ev) {
        ev.stopPropagation();
        self.artir(u, v);
      });
      aksiyon.appendChild(ekle);
    }
    kart.appendChild(aksiyon);

    return kart;
  };

  /* Bir varyanta ait kartı yerinde değiştirir. Kart görünürde değilse
     (arama/havuz değişmiş olabilir) sessizce hiçbir şey yapmaz. */
  WeftyPaket.prototype.kartTazele = function (urun, varyant) {
    var eski = this.izgara.querySelector('[data-varyant="' + varyant.id + '"]');
    if (!eski) return;
    eski.parentNode.replaceChild(this.kartYap(urun, varyant), eski);
  };

  WeftyPaket.prototype.artir = function (urun, varyant) {
    var i = this.secimIndeksi(varyant.id);
    if (i === -1) {
      this.secim.push({
        urunId: urun.id,
        varyantId: varyant.id,
        ad: urun.ad,
        handle: urun.handle,
        gorsel: urun.gorsel,
        olcek: varyant.olcek,
        mm: urun.olcu && urun.olcu.mm ? urun.olcu.mm[varyant.olcek] : null,
        fiyat: varyant.fiyat,
        adet: 1,
      });
    } else {
      this.secim[i].adet += 1;
    }
    this.kartTazele(urun, varyant);
    this.ozetCiz();
  };

  WeftyPaket.prototype.azalt = function (urun, varyant) {
    var i = this.secimIndeksi(varyant.id);
    if (i === -1) return;
    this.secim[i].adet -= 1;
    if (this.secim[i].adet <= 0) this.secim.splice(i, 1);
    this.kartTazele(urun, varyant);
    this.ozetCiz();
  };

  WeftyPaket.prototype.ozetCiz = function () {
    var self = this;
    var adet = this.adet();
    var ara = this.araToplam();
    var aktif = this.aktifKademe(adet);
    var sonraki = this.sonrakiKademe(adet);
    var hakli = !!aktif;
    var inen = aktif ? ara * (aktif.yuzde / 100) : 0;

    /* Sayaç bir SONRAKİ hedefi gösterir; en üst kademedeyken hedef kalmadığı
       için yalnız adet yazar. "40 / 30" gibi anlamsız bir kesir çıkmasın. */
    if (this.sayacEl) {
      this.sayacEl.textContent = sonraki
        ? adet + ' / ' + sonraki.adet
        : String(adet);
      this.sayacEl.classList.toggle('is-tamam', hakli);
    }

    /* Kademe merdiveninde bulunduğun basamağı işaretle. */
    var merdiven = this.ozet.querySelector('[data-wf-kademeler]');
    if (merdiven) {
      merdiven.querySelectorAll('li').forEach(function (li) {
        var esik = parseInt(li.dataset.esik, 10);
        li.classList.toggle('is-aktif', !!aktif && aktif.adet === esik);
        li.classList.toggle('is-gecildi', adet >= esik);
      });
    }

    this.listeEl.innerHTML = '';
    if (!this.secim.length) {
      this.listeEl.appendChild(el('p', 'wf-paket__bilgi',
        'Henüz parça seçilmedi. Soldaki katalogdan ' + this.hedef + ' parça seç.'));
    } else {
      this.secim.forEach(function (s) {
        var satir = el('div', 'wf-paket-satir');
        var ad = adAyir(s.ad);
        var sol = el('div', 'wf-paket-satir__sol');
        sol.appendChild(el('span', 'wf-paket-satir__ad', ad.ust));
        sol.appendChild(el('span', 'wf-paket-satir__meta',
          s.olcek + (s.mm ? ' · ' + s.mm + ' mm' : '') + ' · ' + s.adet + ' adet'));
        satir.appendChild(sol);
        satir.appendChild(el('span', 'wf-paket-satir__fiyat',
          paraBicimlendir(s.fiyat * s.adet, self.paraKodu, self.dil)));
        var sil = el('button', 'wf-paket-satir__sil', '×');
        sil.type = 'button';
        sil.setAttribute('aria-label', s.ad + ' parçasını çıkar');
        sil.addEventListener('click', function () {
          var i = self.secimIndeksi(s.varyantId);
          if (i !== -1) self.secim.splice(i, 1);
          self.izgaraCiz();
          self.ozetCiz();
        });
        satir.appendChild(sil);
        self.listeEl.appendChild(satir);
      });
    }

    this.ozet.querySelector('[data-wf-ara]').textContent =
      paraBicimlendir(ara, this.paraKodu, this.dil);

    var inenEl = this.ozet.querySelector('[data-wf-inen]');
    var inenSatir = this.ozet.querySelector('[data-wf-inen-satir]');
    inenEl.textContent = '−' + paraBicimlendir(inen, this.paraKodu, this.dil);
    var inenEtiket = this.ozet.querySelector('[data-wf-inen-etiket]');
    if (inenEtiket && aktif) {
      inenEtiket.textContent = aktif.adet + '’lu paket indirimi (%' +
        aktif.yuzde + ')';
    }
    inenSatir.hidden = !hakli;

    var odenecek = ara - inen;
    this.ozet.querySelector('[data-wf-toplam]').textContent =
      paraBicimlendir(odenecek, this.paraKodu, this.dil);

    /* Parça başı fiyat. Çoklu alımın kazancı bu sayıda görünür: toplam
       büyürken parça başı düşer. İndirim devredeyse indirimsiz hâli üstü
       çizili yanında durur. Seçim boşken satır gizli — 0'a bölmüyoruz. */
    var birimSatir = this.ozet.querySelector('[data-wf-birim-satir]');
    if (birimSatir) {
      if (adet > 0) {
        this.ozet.querySelector('[data-wf-birim]').textContent =
          paraBicimlendir(odenecek / adet, this.paraKodu, this.dil);
        var eskiEl = this.ozet.querySelector('[data-wf-birim-eski]');
        if (hakli) {
          eskiEl.textContent = paraBicimlendir(ara / adet, this.paraKodu, this.dil);
          eskiEl.hidden = false;
        } else {
          eskiEl.hidden = true;
        }
        birimSatir.hidden = false;
      } else {
        birimSatir.hidden = true;
      }
    }

    if (this.durumEl) {
      var metin;
      if (aktif && sonraki) {
        metin = '%' + aktif.yuzde + ' indirim uygulanıyor. ' +
          (sonraki.adet - adet) + ' parça daha eklersen %' + sonraki.yuzde +
          '’ye çıkıyor.';
      } else if (aktif) {
        metin = '%' + aktif.yuzde + ' indirim uygulanıyor — en yüksek kademe.';
      } else if (sonraki) {
        metin = (sonraki.adet - adet) + ' parça daha eklersen parça başı %' +
          sonraki.yuzde + ' iniyor.';
      } else {
        metin = '';
      }
      this.durumEl.textContent = metin;
      this.durumEl.classList.toggle('is-tamam', hakli);
    }

    /* Ucretsiz kargo gostergesi. Indirim SONRASI tutara bakar — musteri
       odeme adiminda hangi rakami gorecekse burada da onu gorsun. Esik 0 ise
       (ayardan kapatilmissa) satir hic basilmaz. */
    if (this.kargoEl && this.kargoEsik > 0) {
      var odenecek = ara - inen;
      if (adet === 0) {
        this.kargoEl.hidden = true;
      } else if (odenecek >= this.kargoEsik) {
        this.kargoEl.textContent = 'Kargo ücretsiz — ' +
          paraBicimlendir(this.kargoEsik, this.paraKodu, this.dil) + ' eşiği geçildi.';
        this.kargoEl.classList.add('is-tamam');
        this.kargoEl.hidden = false;
      } else {
        this.kargoEl.textContent = 'Ücretsiz kargoya ' +
          paraBicimlendir(this.kargoEsik - odenecek, this.paraKodu, this.dil) + ' kaldı.';
        this.kargoEl.classList.remove('is-tamam');
        this.kargoEl.hidden = false;
      }
    }

    if (this.ekleDugme) {
      this.ekleDugme.disabled = adet === 0;
      this.ekleDugme.textContent = adet === 0
        ? 'Sepete ekle'
        : 'Sepete ekle · ' + adet + ' parça';
    }
  };

  WeftyPaket.prototype.sepeteEkle = function () {
    var self = this;
    if (!this.secim.length) return;

    var kok = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    this.ekleDugme.disabled = true;
    this.ekleDugme.textContent = 'Ekleniyor…';

    fetch(kok + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: self.secim.map(function (s) {
          return { id: s.varyantId, quantity: s.adet };
        }),
      }),
    })
      .then(function (r) {
        return r.json().then(function (d) {
          if (!r.ok) throw new Error(d.description || d.message || ('HTTP ' + r.status));
          return d;
        });
      })
      .then(function () {
        window.location.href = kok + 'cart';
      })
      .catch(function (e) {
        self.ekleDugme.disabled = false;
        self.ozetCiz();
        if (self.durumEl) {
          self.durumEl.textContent = 'Sepete eklenemedi: ' + e.message;
          self.durumEl.classList.remove('is-tamam');
        }
        if (window.console) console.error('[wefty-paket]', e);
      });
  };

  function baslat() {
    document.querySelectorAll('[data-wf-paket]').forEach(function (kok) {
      if (kok.dataset.wfKuruldu) return;
      kok.dataset.wfKuruldu = '1';
      new WeftyPaket(kok);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', baslat);
  } else {
    baslat();
  }

  document.addEventListener('shopify:section:load', baslat);
})();
